import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';

export const useTreeMap = ({ values, subtitles, color }) => {
    const chartConfig = {
        series: [
            {
                data: subtitles.map((sub, index) => ({
                    x: sub,
                    y: values[index]
                }))
            }
        ],
        options: {
            colors: defaultColors,
            plotOptions: {
                treemap: {
                    distributed: true,
                    enableShades: false
                }
            },
            chart: {
                type: 'treemap',
                height: 200,
                toolbar: {
                    show: true
                }
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#333']
                }
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                y: {
                    formatter: (val) => `${val.toLocaleString('pt-BR')}`
                }
            },
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};
